/**
 * Mulberry32 — 32-bit deterministic PRNG. Tiny, fast, and well-distributed
 * for the non-cryptographic uses we have (random-walk vessel motion).
 *
 * Reference: https://github.com/bryc/code/blob/master/jshash/PRNGs.md
 */
export function mulberry32(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Stable 32-bit string hash (FNV-1a). Used to derive a deterministic RNG
 * seed from string ids (vessel id, scenario id) so that two runs of the
 * same scenario produce the same random-walk motion.
 */
export function fnv1a32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function seedFor(...parts: string[]): number {
  return fnv1a32(parts.join("|"));
}
